import Typography from "@mui/material/Typography";
import colors from "../../utils/colors";

/** V2 page heading — 24/32 medium neutral[1000]; font from theme / --layerd-font-sans. */
export const PAGE_TITLE_SX = {
  fontSize: 24,
  lineHeight: "32px",
  fontWeight: "medium",
  color: colors.neutral[1000],
};

export default function PageTitle({ children, component = "h1", sx, ...rest }) {
  return (
    <Typography component={component} sx={{ ...PAGE_TITLE_SX, ...sx }} {...rest}>
      {children}
    </Typography>
  );
}
